/*** 全局指令 ****/
import Vue from "vue";
import drag from "./src/drag";

const directives = {
    drag
};

Object.keys(directives).forEach(item => {
    Vue.directive(item, directives[item]);
});
